var map = {
	"./action_img.png": 750,
	"./business1.png": 751,
	"./business2.png": 752,
	"./h_blog1.jpg": 753,
	"./h_blog2.jpg": 754,
	"./hosting-image.png": 485,
	"./hosting_action_bg.png": 486,
	"./icon1.png": 755,
	"./icon10.png": 756,
	"./icon2.png": 757,
	"./icon3.png": 758,
	"./icon4.png": 759,
	"./icon5.png": 760,
	"./icon6.png": 761,
	"./icon7.png": 762,
	"./icon8.png": 763,
	"./icon9.png": 764,
	"./line_01.png": 487,
	"./line_02.png": 488,
	"./line_03.png": 489,
	"./line_04.png": 490,
	"./line_05.png": 491,
	"./line_06.png": 492,
	"./line_07.png": 493,
	"./line_08.png": 494,
	"./map.png": 765,
	"./region_map.png": 766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;